import { createSelector } from 'reselect'
import { WEEK_STARTS_ON_SUNDAY_COUNTRY_CODES } from '@calendly/booking-kit/constants'

import { countryCodeSelector } from 'selectors'

export const startOfTheWeekSelector = createSelector(
  countryCodeSelector,
  (countryCode) => (WEEK_STARTS_ON_SUNDAY_COUNTRY_CODES.includes(countryCode) ? 'sunday' : 'monday')
)
